// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.social-pane {
  display: block;
  background: var(--color-background, #F8F9FB);
  border-radius: var(--border-radius-base, 0.3125rem);
  overflow: visible;
  width: 100%;
  min-width: 100%;
  box-sizing: border-box;
  max-width: none;
  margin: 0;
}

.social-pane__header-section {
  background:white;
}

.social-pane__header {
  position: relative;
  width: 100%;
}

.social-pane__header-content {
  display: flex;
  align-items: flex-start;
  gap: var(--spacing-lg, 1.5625rem);
  padding: 1.5rem 1.5rem 0.5rem;
}

.social-pane__header-media {
  display: flex;
  flex: 0 0 180px;
  flex-direction: column;
  align-items: flex-start;
  width: 180px;
  gap: var(--spacing-base, 0.5rem);
  overflow: visible;
  border-radius: var(--border-radius-full, 0.625rem);
}

.social-pane__header-details {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--spacing-xs, 0.75rem);
  min-width: 0;
}

.social-pane__header-summary {
  gap: var(--spacing-xs, 0.75rem);
  width: fit-content;
  max-width: 100%;
}

.social-pane__header-stats {
  display: flex;
  flex-wrap: wrap;
  gap: var(--spacing-xs, 0.75rem);
  justify-content: flex-start;
  align-self: flex-start;
}

.social-pane__header-stat {
  appearance: none;
  border: 0;
  background: transparent;
  cursor: pointer;
  color: var(--slate-700, #314158);
  font-size: var(--font-size-sm, 0.875rem);
  font-weight: var(--font-weight-bold, 600);
  line-height: var(--line-height-tight, 1.4);
  padding: 0;
  text-decoration: none;
}

.social-pane__header-stat + .social-pane__header-stat::before {
  content: '◆';
  color: var(--gray-400, #99A1AF);
  font-size: 0.5rem;
  margin-right: var(--spacing-xs, 0.75rem);
  vertical-align: middle;
}

.social-pane__header-stat:hover .social-pane__header-stat-label {
  text-decoration: underline;
}

.social-pane__header-stat:focus-visible {
  outline: var(--border-width-medium, 2px) solid #111827;
  outline-offset: 2px;
}

.social-pane__edit-button {
  position: absolute;
  top: var(--spacing-xs, 0.75rem);
  right: var(--spacing-xs, 0.75rem);
  left: auto;
  z-index: 1;
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  border: 0;
  background: transparent;
  color: var(--color-primary, #7C4DFF);
  padding: 0;
  font-size: var(--font-size-md, 1rem);
  font-weight: var(--font-weight-bold, 600);
  cursor: pointer;
  text-decoration: none;
}

.social-pane__edit-button:hover {
  text-decoration: underline;
}

.social-pane__edit-button:focus-visible {
  outline: var(--border-width-medium, 2px) solid var(--color-primary, #7C4DFF);
  outline-offset: 2px;
}

.social-pane__edit-button-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 0;
}

.social-pane__edit-button-icon svg {
  width: var(--icon-xxs, 1rem);
  height: var(--icon-xs, 1rem);
}

.social-pane__edit-button-icon svg path {
  fill: currentColor;
  stroke: currentColor;
}

.social-pane__friend-action {
  position: absolute;
  top: var(--spacing-xs, 0.75rem);
  right: var(--spacing-xs, 0.75rem);
  z-index: 1;
  width: auto;
  min-width: 0;
  max-width: none;
  padding: var(--spacing-xxs, 0.3125rem) var(--spacing-xs, 0.75rem);
  gap: var(--spacing-xxs, 0.3125rem);
  border-radius: var(--border-radius-md, 0.5rem);
  border: 1px solid var(--color-primary, #7C4DFF);
  background: transparent;
  color: var(--color-primary, #7C4DFF);
  cursor: pointer;
  font: inherit;
  font-weight: var(--font-weight-bold, 600);
}

.social-pane__friend-action:hover {
  background: rgb(124 77 255 / 0.06);
}

.social-pane__friend-action:focus-visible {
  outline: var(--border-width-medium, 2px) solid var(--color-primary, #7C4DFF);
  outline-offset: 2px;
}

.social-pane__dialog-backdrop {
  position: fixed;
  inset: 0;
  z-index: 1000;
  padding: 1rem;
  background: rgb(15 23 42 / 0.45);
}

.social-pane__dialog {
  width: min(32rem, 100%);
  max-height: calc(100vh - 2rem);
  overflow: auto;
  border-radius: 1rem;
  background: var(--white, #fff);
  color: var(--color-text, #111827);
  padding: var(--spacing-md, 1.25rem);
  box-shadow: 0 20px 45px rgb(15 23 42 / 0.25);
}

.social-pane__dialog-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: var(--spacing-md, 1rem);
}

.social-pane__dialog-title {
  margin: 0 0 var(--spacing-base, 0.5rem);
}

.social-pane__dialog-close {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 0;
  background: transparent;
  color: var(--color-text-subheading, #6b7280);
  cursor: pointer;
  padding: 0;
  line-height: 0;
}

.social-pane__dialog-close:hover {
  color: var(--color-text-primary, #364153);
}

.social-pane__dialog-close:focus-visible {
  outline: var(--border-width-medium, 2px) solid var(--color-text-primary, #364153);
  outline-offset: 2px;
}

.social-pane__dialog-close svg {
  width: var(--icon-xxxs, 0.75rem);
  height: var(--icon-xxxs, 0.75rem);
}

.social-pane__dialog-close svg path {
  fill: currentColor;
}

.social-pane__dialog-hint {
  margin: 0 0 var(--spacing-base, 1rem);
  color: var(--color-text-secondary, #4A5565);
}

.social-pane__dialog-form {
  gap: var(--spacing-sm, 0.938rem);
}

.social-pane__dialog-field {
  gap: var(--spacing-xxs, 0.3125rem);
}

.social-pane__dialog-label {
  font-weight: var(--font-weight-bold, 600);
}

.social-pane__dialog-input {
  width: 100%;
  box-sizing: border-box;
  min-height: auto;
  resize: none;
}

.social-pane__dialog-error {
  min-height: 1.25rem;
  margin: 0;
  color: var(--color-warning, red);
}

.social-pane__dialog-actions {
  display: flex;
  justify-content: flex-end;
  gap: var(--spacing-xs, 0.75rem);
}

.social-pane__dialog-button {
  border-radius: var(--border-radius-lg, 0.75rem) !important;
  padding: var(--spacing-2xs, 0.625rem) 1rem;
  font: inherit;
  font-weight: var(--font-weight-bold, 600);
  cursor: pointer;
}

.social-pane__dialog-button:disabled {
  opacity: 0.6;
  cursor: wait;
}

.social-pane__header-name {
  color: var(--color-text-heading, #000);
  font-size: var(--font-size-xxl, 1.75rem); /* 28px */
  font-weight: var(--font-weight-bold, 600);
  margin: 0;
  padding: 0;
  text-indent: 0;
  line-height: 1.2;
  text-align: left;
  transform: none;
}

.social-pane__header-location {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  color: var(--slate-700, #314158);
  font-size: var(--font-size-xs, 0.8125rem);
  font-weight: var(--font-weight-normal, 400);
  line-height: 1.3;
}

.social-pane__header-job-org {
  margin: 0;
  color: var(--color-text-subheading, #101828);
  font-size: var(--font-size-base, 1rem);
  font-weight: var(--font-weight-medium, 500);
  line-height: 1.25;
  text-align: left;
}

.social-pane__header-location-icon {
  line-height: 0;
}

.social-pane__header-location-icon svg {
  width: var(--icon-xxs, 1rem);
  height: var(--icon-xxs, 1rem);
}

.social-profile-links {
  display: grid;
  grid-template-columns: repeat(2, max-content);
  align-items: start;
  column-gap: 1rem;
  row-gap: 0.15rem;
}

.social-pane__header-hero {
  width: 140px;
  height: 140px;
  border-radius: var(--border-radius-full, 0.625rem); /* 10px */;
  border: var(--border-width-sm, 0.1rem) solid var(--color-primary, #7C4DFF);
  background: var(--gray-200, #E5E7EB) 50% / cover no-repeat;
  background-position: 50%;
  object-fit: cover;
  object-position: center;
}

.social-pane__header-hero-icon {
  width: 140px;
  height: 140px;
  border-radius: var(--border-radius-full, 0.625rem) !important;
  border: var(--border-width-sm, 0.1rem) solid var(--color-primary, #7C4DFF);
  background: var(--color-card-bg);
  line-height: 0;
  flex-shrink: 0;
}

.social-pane__header-hero-icon svg {
  display: block;
  width: 100%;
  height: 100%;
}


.social-pane .social-layout {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  width: 100%;
}

.social-pane .social-primary {
  flex: 1 1 70%;
  min-width: 0;
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  grid-template-rows: auto minmax(0, auto);
  gap: 0;
  align-items: start;
}

.social-pane .social-primary__tabs {
  grid-column: 1;
  grid-row: 1;
  display: flex;
  align-items: center;
  gap: var(--spacing-base, 0.5rem);
  padding: 0;
  background: transparent;
  width: fit-content;
  max-width: 100%;
  margin-bottom: 0;
  position: relative;
  z-index: 1;
}

.social-pane .social-primary__tab {
  appearance: none;
  -webkit-appearance: none;
  border: 0;
  border-bottom: var(--border-width-sm, 0.1rem) solid transparent;
  border-radius: 0;
  background: transparent;
  color: #374151;
  cursor: pointer;
  font: inherit;
  font-weight: var(--font-weight-bold, 600);
  padding: var(--spacing-2xs, 0.625rem) 1rem;
  box-shadow: none !important;
  transition: background-color 120ms ease, color 120ms ease, box-shadow 120ms ease;
}

.social-pane .social-primary__tab:hover {
  background: var(--lavender-300, #e6dcff) !important;
  color: var(--grey-purple-900, #332746);
  box-shadow: none !important;
}

.social-pane .social-primary__tab[aria-selected='true'] {
  background: transparent;
  color: var(--grey-purple-900, #332746);
  box-shadow: none !important;
  border-bottom-color: var(--color-primary, #7C4DFF);
}

.social-pane .social-primary__tab:focus-visible {
  outline: none;
  outline-offset: 2px;
  box-shadow: none !important;
}

.social-pane .social-primary__tab--active {
  background: transparent;
  color: var(--grey-purple-900, #332746);
  border-bottom-color: var(--color-primary, #7C4DFF);
  box-shadow: none !important;
}

.social-pane .social-primary__panel {
  grid-column: 1;
  grid-row: 2;
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transform: translateY(0.35rem);
  transition: opacity 160ms ease, transform 160ms ease, visibility 0s linear 160ms;
}

.social-pane .social-primary__panel--active {
  opacity: 1;
  visibility: visible;
  pointer-events: auto;
  border: 0;
  border-bottom: var(--border-width-sm, 0.1rem) solid transparent;
  transition: opacity 180ms ease, transform 180ms ease;
}

.social-pane .social-pane__mutual-friends,
.social-pane .social-pane__all-friends {
  margin-top: 0;
  padding-top: var(--spacing-xxxs, 0.2rem);
}

.social-pane .social-nav {
  display: block;
  width: 100%;
  background-color: var(--gray-200, #E5E7EB);
  background: transparent;
  padding: var(--spacing-base, 0.5rem);
  box-sizing: border-box;
  border-bottom-color: var(--color-primary, #7C4DFF);
}

.social-pane .social-toolbar {
  flex: 0 0 30%;
  min-width: 14rem;
  background-color: var(--gray-200, #E5E7EB);
  border: 0;
  padding: var(--spacing-base, 0.5rem);
  box-sizing: border-box;
  background: transparent;
  border-bottom-color: var(--color-primary, #7C4DFF);
  display: block;
  width: 100%;
  padding-top: 0;
}

.social-pane .social-main {
  display: table;
  background-color: var(--color-card-bg, #fff);
  color: var(--color-text-primary, #364153);
  border: 0;
  padding: 0;
  box-sizing: border-box;
  width: 100%;
  border-collapse: collapse;
}

.social-pane .social-main--mutual {
  gap: var(--spacing-xs, 0.75rem);
  margin-top: 1em;
  margin-bottom: 1em;
  padding: 1rem;
  border-radius: var(--border-radius-lg, 0.75rem);
}

.social-pane .social-mutual-summary {
  gap: var(--spacing-base, 0.5rem);
}

.social-pane .social-mutual-summary-line {
  color: var(--slate-700, #314158);
  font-size: var(--font-size-sm, 0.95rem);
  line-height: var(--line-height-base, 1.5);
  justify-content: flex-start;
  padding: 1rem;
}

.social-pane .social-mutual-summary-line--action {
  flex-wrap: wrap;
  gap: var(--spacing-xxs, 0.75rem);
}

.social-pane .social-mutual-confirm-prompt {
  display: inline-flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--spacing-xxxs, 0.2rem);
  font-weight: var(--font-weight-semibold, 600);
}

.social-pane .social-pane__friend-action--inline {
  position: static;
  top: auto;
  right: auto;
  z-index: auto;
  align-self: flex-start;
}

.social-pane .social-mutual-checkbox-form {
  display: block;
  margin: 0;
}

.social-pane .social-mutual-checkbox-form label {
  display: inline-flex;
  align-items: center;
  gap: var(--spacing-2xs, 0.65rem);
  color: var(--slate-700, #374151);
  font-size: var(--font-size-sm, 0.875rem);
  line-height: 1.4;
}

.social-pane .social-mutual-checkbox-form input[type='checkbox'] {
  width: 1rem;
  height: 1rem;
  margin: 0;
  accent-color: var(--color-primary, #7C4DFF);
}

.social-pane .social-mutual-checkbox-form input[type='checkbox']:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}

.social-pane .social-friends-list {
  width: 100%;
  margin-top: 0;
}

.social-pane .social-friends-grid {
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%;
  table-layout: fixed;
  border-collapse: separate;
  border-spacing: 0;
  gap: var(--spacing-xs, 0.75rem);
}

.social-pane .social-friends-grid > tr {
  display: inline-table;
  width: calc(50% - 0.375rem);
  table-layout: fixed;
  box-sizing: border-box;
}

.social-pane .social-friends-grid > tr,
.social-pane .social-friend-card {
  border: 1px solid var(--gray-200, #E5E7EB);
  background: var(--white, #fff);
  border-radius: var(--border-radius-lg, 0.75rem);
  overflow: visible;
  box-shadow: 0 1px 3px rgb(0 0 0 / 0.08);
  transition: box-shadow 140ms ease, border-color 140ms ease, transform 140ms ease;
}

.social-pane .social-friends-grid > tr:hover,
.social-pane .social-friend-card:hover {
  border-color: var(--gray-300, #D1D5DC);
  box-shadow: 0 6px 18px rgb(0 0 0 / 0.1);
  transform: translateY(-1px);
}

.social-pane .social-friends-grid > tr td,
.social-pane .social-friend-card td {
  background: var(--color-background, #F8F9FB);
}

.social-pane .social-friends-grid td > div > div {
  min-width: 18rem !important;
  max-width: min(90vw, 26rem) !important;
  width: auto !important;
  white-space: normal !important;
}

.social-pane .social-friends-grid td > div > div button {
  white-space: normal !important;
}

/* change the style of the name / label in the friend card */
.social-pane .social-friends-grid > tr > td:nth-child(2) > div:first-child > span {
  display: inline-block;
  width: min(20rem, 100%);
  max-width: 100%;
  vertical-align: text-top;
  font-size: var(--font-size-lg, 1.125rem); /* 18px */
  font-weight: var(--font-weight-bold, 600); /* new design uses 600 */
  line-height: var(--line-height-tight);
  margin-top: 0;
  margin-bottom: var(--spacing-sm);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.social-pane .social-friend-pronouns {
  color: var(--color-text-secondary, #4A5565);
  font-size: var(--font-size-sm, 0.875rem); /* 14px */
  font-weight: var(--font-weight-regular, 400);
  line-height: 1.2;
  text-align: center;
}

.social-pane .social-friend-job-org {
  margin: 0;
  width: 100%;
  white-space: normal;
  color: var(--color-text-subheading, #101828);
  font-size: var(--font-size-sm, 0.875rem);
  font-weight: var(--font-weight-medium, 500);
  line-height: 1.25;
  text-align: left;
}

.social-pane .social-friend-location {
  color: var(--color-text-secondary, #6b7280);
  font-size: var(--font-size-xs, 0.8125rem);
  line-height: 1.3;
}

.social-pane .social-friends-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 var(--spacing-xs, 0.75rem) var(--spacing-base, 0.5rem);
  background-color: var(--gray-100, #F3F4F6);
  caption-side: top;
  margin-top: 0;
}

.social-pane .social-friends-header-title {
  font-size: var(--font-size-md, 1rem);
  font-weight: var(--font-weight-bold, 600);
  color: var(--color-text-primary, #364153);
}

.social-pane .social-friends-header-actions {
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
}

.social-pane .social-friends-header-actions--standalone {
  display: flex;
  align-items: center;
  gap: var(--spacing-xs, 0.75rem);
  justify-content: flex-start;
  padding: 0.7rem 1rem 0;
}

.social-pane .social-friends-header-hint {
  color: var(--color-text-secondary, #4A5565);
  font-size: var(--font-size-sm, 0.875rem);
  line-height: 1.4;
}

.social-pane .social-friends-header-actions button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.5rem !important;
  min-width: 1.5rem !important;
  height: 1.5rem !important;
  padding: 0.125rem !important;
  margin: 0 !important;
  border-width: 0 !important;
}

.social-pane .social-friends-header-actions button img {
  width: var(--icon-base, 2rem) !important;
  height: var(--icon-base, 2rem) !important;
}

.social-pane .social-nav h3 {
  margin-top: 0;
  padding-top: 0;
  border-top: 0;
}

/* From tabbedtab.css */
/* ***************** Social Pane **********/

div.social-pane {
  padding-top: 0;
  padding-bottom: 0;
  margin: 0;
}

.social-pane a {
  color: var(--color-primary, #7C4DFF);
  text-decoration: none;
  font-weight: bold;
}
.social-pane a:link {
  color: var(--color-primary, #7C4DFF);
  text-decoration: none;
  font-weight: bold;
}
.social-pane a:visited {
  color: var(--color-primary, #7C4DFF);
  text-decoration: none;
  font-weight: bold;
}
.social-pane a:hover {
  color: var(--color-primary, #7C4DFF);
  text-decoration: underline;
  font-weight: bold;
}
.social-pane a:active {
  color: var(--color-primary, #7C4DFF);
  text-decoration: none;
}

.social-pane__link-button {
  width: fit-content;
  max-width: 100%;
  display: inline-flex;
  white-space: nowrap;
  background-color: transparent;
  border: none;
  margin-top: 0;
  margin-bottom: 0;
  padding: var(--spacing-xxxs, 0.2rem) var(--spacing-base, 0.5rem);
  text-align: left;
}

.social-pane__link-button > a {
  display: inline-flex;
  white-space: nowrap;
  background-color: transparent;
  color: var(--color-primary, #7C4DFF);
}

.social-pane__link-button > a:link,
.social-pane__link-button > a:visited,
.social-pane__link-button > a:hover {
  color: var(--color-primary, #7C4DFF);
}

.social-pane__link-button > a:hover {
  text-decoration: underline;
}

@media (max-width: 600px) {
  .social-pane__header-content {
    flex-direction: column;
    align-items: flex-start;
  }

  .social-pane .social-layout,
  .social-pane .social-primary {
    display: block;
  }

  .social-pane .social-friends-grid {
    display: block;
  }

  .social-pane .social-friends-grid > tr {
    display: table;
    width: 100%;
    margin-bottom: var(--spacing-xs, 0.75rem);
  }

  .social-pane .social-friends-grid > tr:last-child {
    margin-bottom: 0;
  }

  .social-pane .social-nav,
  .social-pane .social-toolbar,
  .social-pane .social-content,
  .social-pane .social-main {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/social/socialPane.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,4CAA4C;EAC5C,mDAAmD;EACnD,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,iCAAiC;EACjC,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,gCAAgC;EAChC,iBAAiB;EACjB,kDAAkD;AACpD;;AAEA;EACE,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,uBAAuB;EACvB,+BAA+B;EAC/B,YAAY;AACd;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,+BAA+B;EAC/B,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,uBAAuB;EACvB,eAAe;EACf,gCAAgC;EAChC,wCAAwC;EACxC,yCAAyC;EACzC,0CAA0C;EAC1C,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,+BAA+B;EAC/B,iBAAiB;EACjB,wCAAwC;EACxC,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,sDAAsD;EACtD,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,iCAAiC;EACjC,UAAU;EACV,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,SAAS;EACT,uBAAuB;EACvB,oCAAoC;EACpC,UAAU;EACV,oCAAoC;EACpC,yCAAyC;EACzC,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,4EAA4E;EAC5E,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,iCAAiC;EACjC,UAAU;EACV,WAAW;EACX,YAAY;EACZ,eAAe;EACf,iEAAiE;EACjE,kCAAkC;EAClC,8CAA8C;EAC9C,+CAA+C;EAC/C,uBAAuB;EACvB,oCAAoC;EACpC,eAAe;EACf,aAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,4EAA4E;EAC5E,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,uBAAuB;EACvB,8BAA8B;EAC9B,cAAc;EACd,mBAAmB;EACnB,8BAA8B;EAC9B,iCAAiC;EACjC,mCAAmC;EACnC,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,uBAAuB;EACvB,4CAA4C;EAC5C,eAAe;EACf,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,iFAAiF;EACjF,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;AAC7C;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,0DAA0D;EAC1D,0CAA0C;EAC1C,aAAa;EACb,yCAAyC;EACzC,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,sCAAsC;EACtC,wCAAwC,EAAE,SAAS;EACnD,yCAAyC;EACzC,SAAS;EACT,UAAU;EACV,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,gCAAgC;EAChC,yCAAyC;EACzC,2CAA2C;EAC3C,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,4CAA4C;EAC5C,sCAAsC;EACtC,2CAA2C;EAC3C,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,6CAA6C;EAC7C,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kDAAkD,EAAE,SAAS;EAC7D,0EAA0E;EAC1E,0DAA0D;EAC1D,wBAAwB;EACxB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,6DAA6D;EAC7D,0EAA0E;EAC1E,gCAAgC;EAChC,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;;;AAGA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,aAAa;EACb,qCAAqC;EACrC,wCAAwC;EACxC,MAAM;EACN,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,gCAAgC;EAChC,UAAU;EACV,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,SAAS;EACT,+DAA+D;EAC/D,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,aAAa;EACb,yCAAyC;EACzC,0CAA0C;EAC1C,2BAA2B;EAC3B,gFAAgF;AAClF;;AAEA;EACE,mDAAmD;EACnD,sCAAsC;EACtC,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,sCAAsC;EACtC,2BAA2B;EAC3B,kDAAkD;AACpD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,sCAAsC;EACtC,kDAAkD;EAClD,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,oBAAoB;EACpB,8BAA8B;EAC9B,gFAAgF;AAClF;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,oBAAoB;EACpB,SAAS;EACT,+DAA+D;EAC/D,oDAAoD;AACtD;;AAEA;;EAEE,aAAa;EACb,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,WAAW;EACX,0CAA0C;EAC1C,uBAAuB;EACvB,oCAAoC;EACpC,sBAAsB;EACtB,kDAAkD;AACpD;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,0CAA0C;EAC1C,SAAS;EACT,oCAAoC;EACpC,sBAAsB;EACtB,uBAAuB;EACvB,kDAAkD;EAClD,cAAc;EACd,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,4CAA4C;EAC5C,yCAAyC;EACzC,SAAS;EACT,UAAU;EACV,sBAAsB;EACtB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;EAC/B,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,+CAA+C;AACjD;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,uCAAuC;EACvC,yCAAyC;EACzC,2BAA2B;EAC3B,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,mBAAmB;EACnB,gCAAgC;EAChC,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,WAAW;EACX,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gCAAgC;EAChC,gCAAgC;EAChC,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;;EAEE,0CAA0C;EAC1C,8BAA8B;EAC9B,+CAA+C;EAC/C,iBAAiB;EACjB,uCAAuC;EACvC,gFAAgF;AAClF;;AAEA;;EAEE,sCAAsC;EACtC,uCAAuC;EACvC,2BAA2B;AAC7B;;AAEA;;EAEE,4CAA4C;AAC9C;;AAEA;EACE,2BAA2B;EAC3B,sCAAsC;EACtC,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA,4DAA4D;AAC5D;EACE,qBAAqB;EACrB,uBAAuB;EACvB,eAAe;EACf,wBAAwB;EACxB,wCAAwC,EAAE,SAAS;EACnD,yCAAyC,EAAE,wBAAwB;EACnE,qCAAqC;EACrC,aAAa;EACb,gCAAgC;EAChC,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,2CAA2C;EAC3C,wCAAwC,EAAE,SAAS;EACnD,4CAA4C;EAC5C,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,mBAAmB;EACnB,4CAA4C;EAC5C,wCAAwC;EACxC,2CAA2C;EAC3C,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,2CAA2C;EAC3C,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iEAAiE;EACjE,0CAA0C;EAC1C,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,oCAAoC;EACpC,yCAAyC;EACzC,yCAAyC;AAC3C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,+BAA+B;EAC/B,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,2CAA2C;EAC3C,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;EACxB,4BAA4B;EAC5B,yBAAyB;EACzB,4BAA4B;EAC5B,oBAAoB;EACpB,0BAA0B;AAC5B;;AAEA;EACE,wCAAwC;EACxC,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,cAAc;EACd,aAAa;AACf;;AAEA,uBAAuB;AACvB,2CAA2C;;AAE3C;EACE,cAAc;EACd,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE,oCAAoC;EACpC,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE,oCAAoC;EACpC,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE,oCAAoC;EACpC,0BAA0B;EAC1B,iBAAiB;AACnB;AACA;EACE,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,6BAA6B;EAC7B,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,gEAAgE;EAChE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;;;EAGE,oCAAoC;AACtC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;;IAEE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,WAAW;IACX,yCAAyC;EAC3C;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;;;IAIE,WAAW;EACb;AACF","sourcesContent":[".social-pane {\r\n  display: block;\r\n  background: var(--color-background, #F8F9FB);\r\n  border-radius: var(--border-radius-base, 0.3125rem);\r\n  overflow: visible;\r\n  width: 100%;\r\n  min-width: 100%;\r\n  box-sizing: border-box;\r\n  max-width: none;\r\n  margin: 0;\r\n}\r\n\r\n.social-pane__header-section {\r\n  background:white;\r\n}\r\n\r\n.social-pane__header {\r\n  position: relative;\r\n  width: 100%;\r\n}\r\n\r\n.social-pane__header-content {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  gap: var(--spacing-lg, 1.5625rem);\r\n  padding: 1.5rem 1.5rem 0.5rem;\r\n}\r\n\r\n.social-pane__header-media {\r\n  display: flex;\r\n  flex: 0 0 180px;\r\n  flex-direction: column;\r\n  align-items: flex-start;\r\n  width: 180px;\r\n  gap: var(--spacing-base, 0.5rem);\r\n  overflow: visible;\r\n  border-radius: var(--border-radius-full, 0.625rem);\r\n}\r\n\r\n.social-pane__header-details {\r\n  display: flex;\r\n  flex: 1 1 auto;\r\n  flex-direction: column;\r\n  align-items: flex-start;\r\n  gap: var(--spacing-xs, 0.75rem);\r\n  min-width: 0;\r\n}\r\n\r\n.social-pane__header-summary {\r\n  gap: var(--spacing-xs, 0.75rem);\r\n  width: fit-content;\r\n  max-width: 100%;\r\n}\r\n\r\n.social-pane__header-stats {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: var(--spacing-xs, 0.75rem);\r\n  justify-content: flex-start;\r\n  align-self: flex-start;\r\n}\r\n\r\n.social-pane__header-stat {\r\n  appearance: none;\r\n  border: 0;\r\n  background: transparent;\r\n  cursor: pointer;\r\n  color: var(--slate-700, #314158);\r\n  font-size: var(--font-size-sm, 0.875rem);\r\n  font-weight: var(--font-weight-bold, 600);\r\n  line-height: var(--line-height-tight, 1.4);\r\n  padding: 0;\r\n  text-decoration: none;\r\n}\r\n\r\n.social-pane__header-stat + .social-pane__header-stat::before {\r\n  content: '◆';\r\n  color: var(--gray-400, #99A1AF);\r\n  font-size: 0.5rem;\r\n  margin-right: var(--spacing-xs, 0.75rem);\r\n  vertical-align: middle;\r\n}\r\n\r\n.social-pane__header-stat:hover .social-pane__header-stat-label {\r\n  text-decoration: underline;\r\n}\r\n\r\n.social-pane__header-stat:focus-visible {\r\n  outline: var(--border-width-medium, 2px) solid #111827;\r\n  outline-offset: 2px;\r\n}\r\n\r\n.social-pane__edit-button {\r\n  position: absolute;\r\n  top: var(--spacing-xs, 0.75rem);\r\n  right: var(--spacing-xs, 0.75rem);\r\n  left: auto;\r\n  z-index: 1;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 0.45rem;\r\n  border: 0;\r\n  background: transparent;\r\n  color: var(--color-primary, #7C4DFF);\r\n  padding: 0;\r\n  font-size: var(--font-size-md, 1rem);\r\n  font-weight: var(--font-weight-bold, 600);\r\n  cursor: pointer;\r\n  text-decoration: none;\r\n}\r\n\r\n.social-pane__edit-button:hover {\r\n  text-decoration: underline;\r\n}\r\n\r\n.social-pane__edit-button:focus-visible {\r\n  outline: var(--border-width-medium, 2px) solid var(--color-primary, #7C4DFF);\r\n  outline-offset: 2px;\r\n}\r\n\r\n.social-pane__edit-button-icon {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  line-height: 0;\r\n}\r\n\r\n.social-pane__edit-button-icon svg {\r\n  width: var(--icon-xxs, 1rem);\r\n  height: var(--icon-xs, 1rem);\r\n}\r\n\r\n.social-pane__edit-button-icon svg path {\r\n  fill: currentColor;\r\n  stroke: currentColor;\r\n}\r\n\r\n.social-pane__friend-action {\r\n  position: absolute;\r\n  top: var(--spacing-xs, 0.75rem);\r\n  right: var(--spacing-xs, 0.75rem);\r\n  z-index: 1;\r\n  width: auto;\r\n  min-width: 0;\r\n  max-width: none;\r\n  padding: var(--spacing-xxs, 0.3125rem) var(--spacing-xs, 0.75rem);\r\n  gap: var(--spacing-xxs, 0.3125rem);\r\n  border-radius: var(--border-radius-md, 0.5rem);\r\n  border: 1px solid var(--color-primary, #7C4DFF);\r\n  background: transparent;\r\n  color: var(--color-primary, #7C4DFF);\r\n  cursor: pointer;\r\n  font: inherit;\r\n  font-weight: var(--font-weight-bold, 600);\r\n}\r\n\r\n.social-pane__friend-action:hover {\r\n  background: rgb(124 77 255 / 0.06);\r\n}\r\n\r\n.social-pane__friend-action:focus-visible {\r\n  outline: var(--border-width-medium, 2px) solid var(--color-primary, #7C4DFF);\r\n  outline-offset: 2px;\r\n}\r\n\r\n.social-pane__dialog-backdrop {\r\n  position: fixed;\r\n  inset: 0;\r\n  z-index: 1000;\r\n  padding: 1rem;\r\n  background: rgb(15 23 42 / 0.45);\r\n}\r\n\r\n.social-pane__dialog {\r\n  width: min(32rem, 100%);\r\n  max-height: calc(100vh - 2rem);\r\n  overflow: auto;\r\n  border-radius: 1rem;\r\n  background: var(--white, #fff);\r\n  color: var(--color-text, #111827);\r\n  padding: var(--spacing-md, 1.25rem);\r\n  box-shadow: 0 20px 45px rgb(15 23 42 / 0.25);\r\n}\r\n\r\n.social-pane__dialog-header {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  justify-content: space-between;\r\n  gap: var(--spacing-md, 1rem);\r\n}\r\n\r\n.social-pane__dialog-title {\r\n  margin: 0 0 var(--spacing-base, 0.5rem);\r\n}\r\n\r\n.social-pane__dialog-close {\r\n  flex: 0 0 auto;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  border: 0;\r\n  background: transparent;\r\n  color: var(--color-text-subheading, #6b7280);\r\n  cursor: pointer;\r\n  padding: 0;\r\n  line-height: 0;\r\n}\r\n\r\n.social-pane__dialog-close:hover {\r\n  color: var(--color-text-primary, #364153);\r\n}\r\n\r\n.social-pane__dialog-close:focus-visible {\r\n  outline: var(--border-width-medium, 2px) solid var(--color-text-primary, #364153);\r\n  outline-offset: 2px;\r\n}\r\n\r\n.social-pane__dialog-close svg {\r\n  width: var(--icon-xxxs, 0.75rem);\r\n  height: var(--icon-xxxs, 0.75rem);\r\n}\r\n\r\n.social-pane__dialog-close svg path {\r\n  fill: currentColor;\r\n}\r\n\r\n.social-pane__dialog-hint {\r\n  margin: 0 0 var(--spacing-base, 1rem);\r\n  color: var(--color-text-secondary, #4A5565);\r\n}\r\n\r\n.social-pane__dialog-form {\r\n  gap: var(--spacing-sm, 0.938rem);\r\n}\r\n\r\n.social-pane__dialog-field {\r\n  gap: var(--spacing-xxs, 0.3125rem);\r\n}\r\n\r\n.social-pane__dialog-label {\r\n  font-weight: var(--font-weight-bold, 600);\r\n}\r\n\r\n.social-pane__dialog-input {\r\n  width: 100%;\r\n  box-sizing: border-box;\r\n  min-height: auto;\r\n  resize: none;\r\n}\r\n\r\n.social-pane__dialog-error {\r\n  min-height: 1.25rem;\r\n  margin: 0;\r\n  color: var(--color-warning, red);\r\n}\r\n\r\n.social-pane__dialog-actions {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  gap: var(--spacing-xs, 0.75rem);\r\n}\r\n\r\n.social-pane__dialog-button {\r\n  border-radius: var(--border-radius-lg, 0.75rem) !important;\r\n  padding: var(--spacing-2xs, 0.625rem) 1rem;\r\n  font: inherit;\r\n  font-weight: var(--font-weight-bold, 600);\r\n  cursor: pointer;\r\n}\r\n\r\n.social-pane__dialog-button:disabled {\r\n  opacity: 0.6;\r\n  cursor: wait;\r\n}\r\n\r\n.social-pane__header-name {\r\n  color: var(--color-text-heading, #000);\r\n  font-size: var(--font-size-xxl, 1.75rem); /* 28px */\r\n  font-weight: var(--font-weight-bold, 600);\r\n  margin: 0;\r\n  padding: 0;\r\n  text-indent: 0;\r\n  line-height: 1.2;\r\n  text-align: left;\r\n  transform: none;\r\n}\r\n\r\n.social-pane__header-location {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 0.45rem;\r\n  color: var(--slate-700, #314158);\r\n  font-size: var(--font-size-xs, 0.8125rem);\r\n  font-weight: var(--font-weight-normal, 400);\r\n  line-height: 1.3;\r\n}\r\n\r\n.social-pane__header-job-org {\r\n  margin: 0;\r\n  color: var(--color-text-subheading, #101828);\r\n  font-size: var(--font-size-base, 1rem);\r\n  font-weight: var(--font-weight-medium, 500);\r\n  line-height: 1.25;\r\n  text-align: left;\r\n}\r\n\r\n.social-pane__header-location-icon {\r\n  line-height: 0;\r\n}\r\n\r\n.social-pane__header-location-icon svg {\r\n  width: var(--icon-xxs, 1rem);\r\n  height: var(--icon-xxs, 1rem);\r\n}\r\n\r\n.social-profile-links {\r\n  display: grid;\r\n  grid-template-columns: repeat(2, max-content);\r\n  align-items: start;\r\n  column-gap: 1rem;\r\n  row-gap: 0.15rem;\r\n}\r\n\r\n.social-pane__header-hero {\r\n  width: 140px;\r\n  height: 140px;\r\n  border-radius: var(--border-radius-full, 0.625rem); /* 10px */;\r\n  border: var(--border-width-sm, 0.1rem) solid var(--color-primary, #7C4DFF);\r\n  background: var(--gray-200, #E5E7EB) 50% / cover no-repeat;\r\n  background-position: 50%;\r\n  object-fit: cover;\r\n  object-position: center;\r\n}\r\n\r\n.social-pane__header-hero-icon {\r\n  width: 140px;\r\n  height: 140px;\r\n  border-radius: var(--border-radius-full, 0.625rem) !important;\r\n  border: var(--border-width-sm, 0.1rem) solid var(--color-primary, #7C4DFF);\r\n  background: var(--color-card-bg);\r\n  line-height: 0;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.social-pane__header-hero-icon svg {\r\n  display: block;\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n\r\n\r\n.social-pane .social-layout {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  gap: 1rem;\r\n  width: 100%;\r\n}\r\n\r\n.social-pane .social-primary {\r\n  flex: 1 1 70%;\r\n  min-width: 0;\r\n  display: grid;\r\n  grid-template-columns: minmax(0, 1fr);\r\n  grid-template-rows: auto minmax(0, auto);\r\n  gap: 0;\r\n  align-items: start;\r\n}\r\n\r\n.social-pane .social-primary__tabs {\r\n  grid-column: 1;\r\n  grid-row: 1;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: var(--spacing-base, 0.5rem);\r\n  padding: 0;\r\n  background: transparent;\r\n  width: fit-content;\r\n  max-width: 100%;\r\n  margin-bottom: 0;\r\n  position: relative;\r\n  z-index: 1;\r\n}\r\n\r\n.social-pane .social-primary__tab {\r\n  appearance: none;\r\n  -webkit-appearance: none;\r\n  border: 0;\r\n  border-bottom: var(--border-width-sm, 0.1rem) solid transparent;\r\n  border-radius: 0;\r\n  background: transparent;\r\n  color: #374151;\r\n  cursor: pointer;\r\n  font: inherit;\r\n  font-weight: var(--font-weight-bold, 600);\r\n  padding: var(--spacing-2xs, 0.625rem) 1rem;\r\n  box-shadow: none !important;\r\n  transition: background-color 120ms ease, color 120ms ease, box-shadow 120ms ease;\r\n}\r\n\r\n.social-pane .social-primary__tab:hover {\r\n  background: var(--lavender-300, #e6dcff) !important;\r\n  color: var(--grey-purple-900, #332746);\r\n  box-shadow: none !important;\r\n}\r\n\r\n.social-pane .social-primary__tab[aria-selected='true'] {\r\n  background: transparent;\r\n  color: var(--grey-purple-900, #332746);\r\n  box-shadow: none !important;\r\n  border-bottom-color: var(--color-primary, #7C4DFF);\r\n}\r\n\r\n.social-pane .social-primary__tab:focus-visible {\r\n  outline: none;\r\n  outline-offset: 2px;\r\n  box-shadow: none !important;\r\n}\r\n\r\n.social-pane .social-primary__tab--active {\r\n  background: transparent;\r\n  color: var(--grey-purple-900, #332746);\r\n  border-bottom-color: var(--color-primary, #7C4DFF);\r\n  box-shadow: none !important;\r\n}\r\n\r\n.social-pane .social-primary__panel {\r\n  grid-column: 1;\r\n  grid-row: 2;\r\n  opacity: 0;\r\n  visibility: hidden;\r\n  pointer-events: none;\r\n  transform: translateY(0.35rem);\r\n  transition: opacity 160ms ease, transform 160ms ease, visibility 0s linear 160ms;\r\n}\r\n\r\n.social-pane .social-primary__panel--active {\r\n  opacity: 1;\r\n  visibility: visible;\r\n  pointer-events: auto;\r\n  border: 0;\r\n  border-bottom: var(--border-width-sm, 0.1rem) solid transparent;\r\n  transition: opacity 180ms ease, transform 180ms ease;\r\n}\r\n\r\n.social-pane .social-pane__mutual-friends,\r\n.social-pane .social-pane__all-friends {\r\n  margin-top: 0;\r\n  padding-top: var(--spacing-xxxs, 0.2rem);\r\n}\r\n\r\n.social-pane .social-nav {\r\n  display: block;\r\n  width: 100%;\r\n  background-color: var(--gray-200, #E5E7EB);\r\n  background: transparent;\r\n  padding: var(--spacing-base, 0.5rem);\r\n  box-sizing: border-box;\r\n  border-bottom-color: var(--color-primary, #7C4DFF);\r\n}\r\n\r\n.social-pane .social-toolbar {\r\n  flex: 0 0 30%;\r\n  min-width: 14rem;\r\n  background-color: var(--gray-200, #E5E7EB);\r\n  border: 0;\r\n  padding: var(--spacing-base, 0.5rem);\r\n  box-sizing: border-box;\r\n  background: transparent;\r\n  border-bottom-color: var(--color-primary, #7C4DFF);\r\n  display: block;\r\n  width: 100%;\r\n  padding-top: 0;\r\n}\r\n\r\n.social-pane .social-main {\r\n  display: table;\r\n  background-color: var(--color-card-bg, #fff);\r\n  color: var(--color-text-primary, #364153);\r\n  border: 0;\r\n  padding: 0;\r\n  box-sizing: border-box;\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n}\r\n\r\n.social-pane .social-main--mutual {\r\n  gap: var(--spacing-xs, 0.75rem);\r\n  margin-top: 1em;\r\n  margin-bottom: 1em;\r\n  padding: 1rem;\r\n  border-radius: var(--border-radius-lg, 0.75rem);\r\n}\r\n\r\n.social-pane .social-mutual-summary {\r\n  gap: var(--spacing-base, 0.5rem);\r\n}\r\n\r\n.social-pane .social-mutual-summary-line {\r\n  color: var(--slate-700, #314158);\r\n  font-size: var(--font-size-sm, 0.95rem);\r\n  line-height: var(--line-height-base, 1.5);\r\n  justify-content: flex-start;\r\n  padding: 1rem;\r\n}\r\n\r\n.social-pane .social-mutual-summary-line--action {\r\n  flex-wrap: wrap;\r\n  gap: var(--spacing-xxs, 0.75rem);\r\n}\r\n\r\n.social-pane .social-mutual-confirm-prompt {\r\n  display: inline-flex;\r\n  flex-wrap: wrap;\r\n  align-items: center;\r\n  gap: var(--spacing-xxxs, 0.2rem);\r\n  font-weight: var(--font-weight-semibold, 600);\r\n}\r\n\r\n.social-pane .social-pane__friend-action--inline {\r\n  position: static;\r\n  top: auto;\r\n  right: auto;\r\n  z-index: auto;\r\n  align-self: flex-start;\r\n}\r\n\r\n.social-pane .social-mutual-checkbox-form {\r\n  display: block;\r\n  margin: 0;\r\n}\r\n\r\n.social-pane .social-mutual-checkbox-form label {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: var(--spacing-2xs, 0.65rem);\r\n  color: var(--slate-700, #374151);\r\n  font-size: var(--font-size-sm, 0.875rem);\r\n  line-height: 1.4;\r\n}\r\n\r\n.social-pane .social-mutual-checkbox-form input[type='checkbox'] {\r\n  width: 1rem;\r\n  height: 1rem;\r\n  margin: 0;\r\n  accent-color: var(--color-primary, #7C4DFF);\r\n}\r\n\r\n.social-pane .social-mutual-checkbox-form input[type='checkbox']:disabled {\r\n  opacity: 0.65;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.social-pane .social-friends-list {\r\n  width: 100%;\r\n  margin-top: 0;\r\n}\r\n\r\n.social-pane .social-friends-grid {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  align-items: stretch;\r\n  width: 100%;\r\n  table-layout: fixed;\r\n  border-collapse: separate;\r\n  border-spacing: 0;\r\n  gap: var(--spacing-xs, 0.75rem);\r\n}\r\n\r\n.social-pane .social-friends-grid > tr {\r\n  display: inline-table;\r\n  width: calc(50% - 0.375rem);\r\n  table-layout: fixed;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.social-pane .social-friends-grid > tr,\r\n.social-pane .social-friend-card {\r\n  border: 1px solid var(--gray-200, #E5E7EB);\r\n  background: var(--white, #fff);\r\n  border-radius: var(--border-radius-lg, 0.75rem);\r\n  overflow: visible;\r\n  box-shadow: 0 1px 3px rgb(0 0 0 / 0.08);\r\n  transition: box-shadow 140ms ease, border-color 140ms ease, transform 140ms ease;\r\n}\r\n\r\n.social-pane .social-friends-grid > tr:hover,\r\n.social-pane .social-friend-card:hover {\r\n  border-color: var(--gray-300, #D1D5DC);\r\n  box-shadow: 0 6px 18px rgb(0 0 0 / 0.1);\r\n  transform: translateY(-1px);\r\n}\r\n\r\n.social-pane .social-friends-grid > tr td,\r\n.social-pane .social-friend-card td {\r\n  background: var(--color-background, #F8F9FB);\r\n}\r\n\r\n.social-pane .social-friends-grid td > div > div {\r\n  min-width: 18rem !important;\r\n  max-width: min(90vw, 26rem) !important;\r\n  width: auto !important;\r\n  white-space: normal !important;\r\n}\r\n\r\n.social-pane .social-friends-grid td > div > div button {\r\n  white-space: normal !important;\r\n}\r\n\r\n/* change the style of the name / label in the friend card */\r\n.social-pane .social-friends-grid > tr > td:nth-child(2) > div:first-child > span {\r\n  display: inline-block;\r\n  width: min(20rem, 100%);\r\n  max-width: 100%;\r\n  vertical-align: text-top;\r\n  font-size: var(--font-size-lg, 1.125rem); /* 18px */\r\n  font-weight: var(--font-weight-bold, 600); /* new design uses 600 */\r\n  line-height: var(--line-height-tight);\r\n  margin-top: 0;\r\n  margin-bottom: var(--spacing-sm);\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n.social-pane .social-friend-pronouns {\r\n  color: var(--color-text-secondary, #4A5565);\r\n  font-size: var(--font-size-sm, 0.875rem); /* 14px */\r\n  font-weight: var(--font-weight-regular, 400);\r\n  line-height: 1.2;\r\n  text-align: center;\r\n}\r\n\r\n.social-pane .social-friend-job-org {\r\n  margin: 0;\r\n  width: 100%;\r\n  white-space: normal;\r\n  color: var(--color-text-subheading, #101828);\r\n  font-size: var(--font-size-sm, 0.875rem);\r\n  font-weight: var(--font-weight-medium, 500);\r\n  line-height: 1.25;\r\n  text-align: left;\r\n}\r\n\r\n.social-pane .social-friend-location {\r\n  color: var(--color-text-secondary, #6b7280);\r\n  font-size: var(--font-size-xs, 0.8125rem);\r\n  line-height: 1.3;\r\n}\r\n\r\n.social-pane .social-friends-header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding: 0 var(--spacing-xs, 0.75rem) var(--spacing-base, 0.5rem);\r\n  background-color: var(--gray-100, #F3F4F6);\r\n  caption-side: top;\r\n  margin-top: 0;\r\n}\r\n\r\n.social-pane .social-friends-header-title {\r\n  font-size: var(--font-size-md, 1rem);\r\n  font-weight: var(--font-weight-bold, 600);\r\n  color: var(--color-text-primary, #364153);\r\n}\r\n\r\n.social-pane .social-friends-header-actions {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: flex-end;\r\n}\r\n\r\n.social-pane .social-friends-header-actions--standalone {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: var(--spacing-xs, 0.75rem);\r\n  justify-content: flex-start;\r\n  padding: 0.7rem 1rem 0;\r\n}\r\n\r\n.social-pane .social-friends-header-hint {\r\n  color: var(--color-text-secondary, #4A5565);\r\n  font-size: var(--font-size-sm, 0.875rem);\r\n  line-height: 1.4;\r\n}\r\n\r\n.social-pane .social-friends-header-actions button {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 1.5rem !important;\r\n  min-width: 1.5rem !important;\r\n  height: 1.5rem !important;\r\n  padding: 0.125rem !important;\r\n  margin: 0 !important;\r\n  border-width: 0 !important;\r\n}\r\n\r\n.social-pane .social-friends-header-actions button img {\r\n  width: var(--icon-base, 2rem) !important;\r\n  height: var(--icon-base, 2rem) !important;\r\n}\r\n\r\n.social-pane .social-nav h3 {\r\n  margin-top: 0;\r\n  padding-top: 0;\r\n  border-top: 0;\r\n}\r\n\r\n/* From tabbedtab.css */\r\n/* ***************** Social Pane **********/\r\n\r\ndiv.social-pane {\r\n  padding-top: 0;\r\n  padding-bottom: 0;\r\n  margin: 0;\r\n}\r\n\r\n.social-pane a {\r\n  color: var(--color-primary, #7C4DFF);\r\n  text-decoration: none;\r\n  font-weight: bold;\r\n}\r\n.social-pane a:link {\r\n  color: var(--color-primary, #7C4DFF);\r\n  text-decoration: none;\r\n  font-weight: bold;\r\n}\r\n.social-pane a:visited {\r\n  color: var(--color-primary, #7C4DFF);\r\n  text-decoration: none;\r\n  font-weight: bold;\r\n}\r\n.social-pane a:hover {\r\n  color: var(--color-primary, #7C4DFF);\r\n  text-decoration: underline;\r\n  font-weight: bold;\r\n}\r\n.social-pane a:active {\r\n  color: var(--color-primary, #7C4DFF);\r\n  text-decoration: none;\r\n}\r\n\r\n.social-pane__link-button {\r\n  width: fit-content;\r\n  max-width: 100%;\r\n  display: inline-flex;\r\n  white-space: nowrap;\r\n  background-color: transparent;\r\n  border: none;\r\n  margin-top: 0;\r\n  margin-bottom: 0;\r\n  padding: var(--spacing-xxxs, 0.2rem) var(--spacing-base, 0.5rem);\r\n  text-align: left;\r\n}\r\n\r\n.social-pane__link-button > a {\r\n  display: inline-flex;\r\n  white-space: nowrap;\r\n  background-color: transparent;\r\n  color: var(--color-primary, #7C4DFF);\r\n}\r\n\r\n.social-pane__link-button > a:link,\r\n.social-pane__link-button > a:visited,\r\n.social-pane__link-button > a:hover {\r\n  color: var(--color-primary, #7C4DFF);\r\n}\r\n\r\n.social-pane__link-button > a:hover {\r\n  text-decoration: underline;\r\n}\r\n\r\n@media (max-width: 600px) {\r\n  .social-pane__header-content {\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n  }\r\n\r\n  .social-pane .social-layout,\r\n  .social-pane .social-primary {\r\n    display: block;\r\n  }\r\n\r\n  .social-pane .social-friends-grid {\r\n    display: block;\r\n  }\r\n\r\n  .social-pane .social-friends-grid > tr {\r\n    display: table;\r\n    width: 100%;\r\n    margin-bottom: var(--spacing-xs, 0.75rem);\r\n  }\r\n\r\n  .social-pane .social-friends-grid > tr:last-child {\r\n    margin-bottom: 0;\r\n  }\r\n\r\n  .social-pane .social-nav,\r\n  .social-pane .social-toolbar,\r\n  .social-pane .social-content,\r\n  .social-pane .social-main {\r\n    width: 100%;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
